import React, { Component } from "react";
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

class CustomSlide extends Component {
  render() {
    const { index, ...props } = this.props;
    return (
      <div {...props}></div>
    );
  }
}

export default class Responsive extends Component {
  render() {
    var settings = {
      dots: true,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      initialSlide: 0,
      responsive: [
        {
          breakpoint: 1900,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            initialSlide: 2,
            dots: true
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true
          }
        }
      ]
    };
    return (
    <section className='container-fluid wraper-testimony'
    style={{backgroundImage: `url(${'./img/witalytestimony.jpg'})`}}>
      <div className='row m-10-hor'>
        <div className='testimony'>
          <Slider {...settings}>

            <CustomSlide className='itm' index={1}>
              <div className='blockquote'>
                <div className="fa fa-quote-left"></div>
                <div className="conesti">
                  <p>
                    Witaly Group transformed our home beyond what we imagined.
                    Every detail was considered, every finish was flawless.
                    We couldn't be happier with the result.
                  </p>
                  <div className="bytesti">
                    Victor &mdash; Residential Client, Nairobi
                  </div>
                </div>
              </div>
            </CustomSlide>

            <CustomSlide className='itm' index={2}>
              <div className='blockquote'>
                <div className="fa fa-quote-left"></div>
                <div className="conesti">
                  <p>
                    From the initial concept to the final handover, the team was
                    professional, creative, and communicative. Our villa feels
                    like a true luxury retreat.
                  </p>
                  <div className="bytesti">
                    Georgina &mdash; Villa Owner, Mombasa
                  </div>
                </div>
              </div>
            </CustomSlide>

            <CustomSlide className='itm' index={3}>
              <div className='blockquote'>
                <div className="fa fa-quote-left"></div>
                <div className="conesti">
                  <p>
                    They understood our brand immediately and designed a space
                    our guests keep complimenting. The atmosphere Witaly created
                    is a core part of our dining experience.
                  </p>
                  <div className="bytesti">
                    Ken &mdash; Restaurant Owner, Karen
                  </div>
                </div>
              </div>
            </CustomSlide>

            <CustomSlide className='itm' index={4}>
              <div className='blockquote'>
                <div className="fa fa-quote-left"></div>
                <div className="conesti">
                  <p>
                    The attention to detail and quality of materials was
                    exceptional. Delivered on time, within budget, and exceeded
                    every expectation we had for our hotel lobby.
                  </p>
                  <div className="bytesti">
                    Franline &mdash; Hotel Manager, Nairobi
                  </div>
                </div>
              </div>
            </CustomSlide>

          </Slider>
        </div>
      </div>
    </section>
    );
  }
}
